import { HvlAbstractOperationalForm, HvlFormConstants } from '@hvlng/framework-core/form';
import { Directive, Injector, OnDestroy } from '@angular/core';
import { logComponent } from '../hr-logger';
import { HrFormToolbarEvents } from './hr-form-toolbar-events';
import { getFormTitleAsync, getFormTitleSync, goMasterData, translateAsync } from '../page-code/page-code-func';
import { PageCode } from '../page-code/page-code';
import { PageCodeModel } from '../page-code/page-code-model';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HrBaseParam } from './hr-base-param';
import { HrResourceName } from '../model/hr-resource-name';
import { HrResourceLoader } from '../service/hr-resource-loader';
import { HrTranslateKey } from '../translate/hr-translate-key';
import { HrBaseListPageNew } from './hr-base-list-page-new';
import { UiConfirmationDialogService } from 'ui-shared';
import { Subscription } from 'rxjs';

@Directive()
export abstract class HrBasePageNew extends HvlAbstractOperationalForm implements HrFormToolbarEvents, OnDestroy {
    private _pageCodeModel: PageCodeModel;
    private _pageTitle: string;
    private _listTitle: string;
    private _searchTitle: string;
    private _contentVisible = false;

    private resourceLoader: HrResourceLoader;
    protected translateService: TranslateService;
    public confirmationDialogService: UiConfirmationDialogService;
    public router?: Router;
    peopleSubscription: Subscription;

    protected constructor(pageCode: PageCode, injector: Injector, params?: HrBaseParam) {
        super();
        logComponent(this);
        this.initVariables(pageCode, injector, params);
        this.initResources();
    }

    public abstract getResourceList(): Array<HrResourceName>;

    public abstract getFormComponent(): HrFormToolbarEvents;

    public abstract getListComponent(): HrBaseListPageNew<any>;

    public abstract onRowSelected(selectedItem: any);

    public abstract onResourcesLoaded();

    private initVariables(pageCode: PageCode, injector: Injector, params?: HrBaseParam) {
        this._pageCodeModel = new PageCodeModel(pageCode);
        this.translateService = injector.get(TranslateService);
        this.confirmationDialogService = injector.get(UiConfirmationDialogService);
        this.resourceLoader = injector.get(HrResourceLoader);
        if (params?.hasRouter) {
            this.router = injector.get(Router);
        }
    }

    private initResources() {
        this.resourceLoader.init(this.getResourceList()).subscribe((value) => {
            this.onResourcesLoaded();
            this.showContent();
        });
    }

    public openAddForm() {
        this.openPageForm(HvlFormConstants.ADD);
        this.getFormComponent().openAddForm();
    }

    public openCopyForm() {
        this.openPageForm(HvlFormConstants.COPY);
        this.getFormComponent().openCopyForm();
    }

    public openEditForm() {
        this.openPageForm(HvlFormConstants.EDIT);
        this.getFormComponent().openEditForm();
    }

    public openRemoveForm() {
        this.openPageForm(HvlFormConstants.REMOVE);
        this.getFormComponent().openRemoveForm();
    }

    public openViewForm() {
        this.openPageForm(HvlFormConstants.EDIT);
        this.getFormComponent().openViewForm();
    }

    private openPageForm(formMode: HvlFormConstants) {
        this.formVisibility = true;
    }

    get pageCodeModel(): PageCodeModel {
        return this._pageCodeModel;
    }

    get pageTitle(): string {
        return this._pageTitle;
    }

    set pageTitle(value: string) {
        this._pageTitle = value;
    }

    get listTitle(): string {
        return this._listTitle;
    }

    set listTitle(value: string) {
        this._listTitle = value;
    }

    get searchTitle(): string {
        return this._searchTitle;
    }

    set searchTitle(value: string) {
        this._searchTitle = value;
    }

    get contentVisible(): boolean {
        return this._contentVisible;
    }

    public showContent() {
        this._contentVisible = true;
    }

    public showLoading() {}

    public hideLoading() {}

    public goMasterData() {
        goMasterData(this.router);
    }

    public get hrKey(): typeof HrTranslateKey {
        return HrTranslateKey;
    }

    public translateSync(key: string): string | any {
        return this.translateService.instant(key);
    }

    public translateAsync(key: string): Promise<string | any> {
        return translateAsync(this.translateService, key);
    }

    public async getFormTitleAsyncAsSearch(pageTitle: string): Promise<string | any> {
        return getFormTitleAsync(this.translateService, pageTitle, null);
    }

    public async getFormTitleAsync(pageTitle: string, formModeParam?: HvlFormConstants): Promise<string | any> {
        return getFormTitleAsync(
            this.translateService,
            pageTitle,
            formModeParam != null ? formModeParam : this.formMode,
        );
    }

    public getFormTitleSyncAsSearch(pageTitle: string): string | any {
        return getFormTitleSync(this.translateService, pageTitle, null);
    }

    public getFormTitleSync(pageTitle: string, formModeParam?: HvlFormConstants): string | any {
        return getFormTitleSync(
            this.translateService,
            pageTitle,
            formModeParam != null ? formModeParam : this.formMode,
        );
    }

    public closeForm(): void {
        super.closeForm();
        this.getListComponent()?.clearSelectedItem();
        this.formMode = HvlFormConstants.LIST;
    }

    public closeFormWithRefresh(refreshTable: boolean): void {
        this.closeForm();
        if (refreshTable) {
            this.getListComponent()?.refreshTable();
        }
    }

    public onRowSelect(selectedItem: any) {
        this.setButtonItemSelectedMode();
        this.onRowSelected(selectedItem);
    }

    public onRowUnSelect() {
        this.setButtonItemUnSelectedMode();
    }

    ngOnDestroy() {
        if (this.peopleSubscription) this.peopleSubscription.unsubscribe();
        super.ngOnDestroy();
    }
}
